var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgGreenCheckd(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12 2.30179C10.0815 2.30179 8.20606 2.8707 6.61087 3.93657C5.01568 5.00244 3.77238 6.5174 3.03819 8.28988C2.30401 10.0624 2.11191 12.0127 2.4862 13.8944C2.86048 15.7761 3.78433 17.5045 5.14093 18.8611C6.49753 20.2177 8.22594 21.1415 10.1076 21.5158C11.9892 21.8901 13.9396 21.698 15.7121 20.9638C17.4846 20.2296 18.9996 18.9863 20.0654 17.3911C21.1313 15.7959 21.7002 13.9205 21.7002 12.002C21.6973 9.43024 20.6743 6.96466 18.8558 5.14615C17.0373 3.32765 14.5718 2.30472 12 2.30179ZM15.4951 10.4971L11.4951 14.4971C11.3638 14.6284 11.1857 14.7022 11 14.7022C10.8143 14.7022 10.6362 14.6284 10.5049 14.4971L8.50489 12.4971C8.37436 12.3656 8.30126 12.1878 8.30159 12.0025C8.30193 11.8172 8.37567 11.6397 8.50668 11.5087C8.63768 11.3777 8.81527 11.3039 9.00053 11.3036C9.1858 11.3032 9.36365 11.3763 9.49513 11.5069L11 13.0122L14.5049 9.50687C14.6364 9.37634 14.8142 9.30324 14.9995 9.30357C15.1848 9.30391 15.3623 9.37765 15.4933 9.50866C15.6243 9.63966 15.6981 9.81725 15.6984 10.0025C15.6988 10.1878 15.6257 10.3656 15.4951 10.4971Z",
    fill: "#439D62"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGreenCheckd);
export default __webpack_public_path__ + "static/media/green-checkd.241382b19a834ce82df084c59cd24451.svg";
export { ForwardRef as ReactComponent };